import { API } from '@ospace/shared'

const getStats = async () => {
  return await API.get('client', `/stats`, {})
}

export const StatsService = {
  getStats,
}
